export default __webpack_public_path__ + "static/media/character1.6f5f3a5e.png";